import { render, staticRenderFns } from "./DynamicFieldsForm.vue?vue&type=template&id=3050b773&scoped=true&"
import script from "./DynamicFieldsForm.vue?vue&type=script&lang=ts&"
export * from "./DynamicFieldsForm.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicFieldsForm.vue?vue&type=style&index=0&id=3050b773&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3050b773",
  null
  
)

export default component.exports